 //! NOTE: This mixin MUST be imported before the storage mixin, so that storage can load the state that this mixin has saved.
export default {
    created() {
        if (location.search) {
            this.decryptQueryString();
        }
    },
    methods: {
        decryptQueryString() {
            const params = new URLSearchParams(location.search.toLowerCase());

            // If the query string has a 'solution' parameter
            if (params.has('solution')) {
                // Select that box
                this.preselection.boxes.find(x => x.apiName.toLowerCase() == params.get('solution')).isSelected = true;
                // Deselect the row
                this.preselection.isSelected = false;
        
                // Save state to session storage
                sessionStorage.setItem(`store-${this.$store.state.schema}wrapper`, JSON.stringify(this.$store.state));
            }
        },
    }
}